import {ReportingService, SelectedAccount} from '@reporting/reporting.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {AppValidators, EMAIL_MAX_LENGTH, TranslatePipe} from '@brunata-angular/util';
import {CommonModule} from '@angular/common';
import {
    ReportingAccount,
    ReportingBuildingPeriod,
} from '@reporting/overview/account-overview.model';
import {CheckboxGroupComponent, DatePipe, LoadComponent} from '@brunata-angular/ui';
import {Observable} from 'rxjs';
import {InputTextGroupComponent} from '@brunata-angular/ui';
import {
    FormBuilder,
    FormControl,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';

@Component({
    selector: 'app-approve-resident-list-modal',
    templateUrl: './approve-resident-list-modal.component.html',
    styleUrls: ['./approve-resident-list-modal.component.scss'],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CheckboxGroupComponent,
        TranslatePipe,
        DatePipe,
        LoadComponent,
        InputTextGroupComponent,
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApproveResidentListModalComponent {
    @Input() saveLocations$: Observable<boolean> = new Observable<boolean>();

    @Output() approveAccount = new EventEmitter<{
        buildingPeriod: ReportingBuildingPeriod;
        account: ReportingAccount;
        email: string | null;
    }>();

    readonly selectedAccount$: Observable<SelectedAccount | null> =
        this.reportingService.selectedAccount$;

    protected readonly emailMaxLength = EMAIL_MAX_LENGTH;

    formGroup = this.formBuilder.group({
        sendEmail: new FormControl<boolean>(false),
        email: [{value: null, disabled: true}, [Validators.required, AppValidators.email]],
    });
    constructor(
        public activeModal: NgbActiveModal,
        private reportingService: ReportingService,
        private formBuilder: FormBuilder,
    ) {
        this.formGroup.controls.sendEmail.valueChanges.subscribe(sendReceiptByMail => {
            if (sendReceiptByMail ?? false) {
                this.formGroup.controls.email.enable();
            } else {
                this.formGroup.controls.email.disable();
            }
        });
    }

    approve(buildingPeriod: ReportingBuildingPeriod, account: ReportingAccount): void {
        this.formGroup.markAllAsTouched();
        if (this.formGroup.valid) {
            this.approveAccount.next({
                buildingPeriod,
                account,
                email: this.formGroup.value.email ?? null,
            });
        }
    }
}
